import cx from 'classnames';
import { FunctionComponent, ReactNode, TableHTMLAttributes } from 'react';
import styles from './Table.module.scss';

type TableProps = TableHTMLAttributes<HTMLTableElement> & {
    children: ReactNode;
    withPagination?: boolean;
};

export const Table: FunctionComponent<TableProps> = ({ children, withPagination = false, className, ...props }) => {
    return (
        <table className={cx(styles.table, { [styles['table--with-pagination']]: withPagination }, className)} {...props}>
            {children}
        </table>
    );
};

type TableHeadProps = {
    children: ReactNode;
    className?: string;
};

export const TableHead: FunctionComponent<TableHeadProps> = ({ children, className }) => {
    return <thead className={cx(styles.head, className)}>{children}</thead>;
};

export type SortDirection = 'ascending' | 'descending' | 'none';

type TableHeaderProps = {
    children: ReactNode;
    onClick?: () => void;
    sortDirection?: SortDirection;
    className?: string;
};

export const TableHeader: FunctionComponent<TableHeaderProps> = ({ children, onClick, sortDirection, className }) => {
    return (
        <th
            className={cx(
                styles.header,
                {
                    [styles['header--ascending']]: sortDirection === 'ascending',
                    [styles['header--descending']]: sortDirection === 'descending',
                    [styles['header--no-sort']]: sortDirection === 'none',
                },
                className,
            )}
            aria-sort={sortDirection}
        >
            {sortDirection !== undefined ? (
                <button type="button" className={styles.sortButton} onClick={onClick}>
                    {children}
                </button>
            ) : (
                children
            )}
        </th>
    );
};

type TableRowProps = {
    children: ReactNode;
    onClick?: () => void;
    className?: string;
};

export const TableRow: FunctionComponent<TableRowProps> = ({ children, onClick, className }) => {
    return (
        <tr className={cx(styles.row, className)} onClick={onClick}>
            {children}
        </tr>
    );
};
